import React from "react";
import { Button } from "@/components/ui/button";
import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";
import { useUnitJourneyContext } from "@/hooks/useUnitJourneyContext";

type JourneyStep = "vbp" | "rent-reserve-quote";

export const SelectButton = React.forwardRef<HTMLButtonElement>(
    (props, ref) => {
        const { unitGroup } = useUnitItemContext();
        const displayOptions = useDisplayOptionContext();
        const { isOpen, setIsOpen, setUnitJourneyStep } =
            useUnitJourneyContext();

        const handleSelectEvent = () => {
            // If there are multiple subgroups, go to VBP step; otherwise, go to rent-reserve-quote step
            const hasMultipleSubGroups =
                Array.isArray(unitGroup.sub_groups) &&
                unitGroup.sub_groups.length > 1;

            const step: JourneyStep = hasMultipleSubGroups
                ? "vbp"
                : "rent-reserve-quote";

            // Toggle the journey drawer/modal and set the appropriate step
            setUnitJourneyStep(step);
            setIsOpen(!isOpen);
        };

        const label = displayOptions.language?.action?.selectButton ?? "Select";

        return (
            <Button
                ref={ref}
                variant="default"
                data-testid="selectButton"
                onClick={handleSelectEvent}
                type="button"
                aria-label={label}
                {...props}
            >
                {label}
            </Button>
        );
    },
);

SelectButton.displayName = "SelectButton";
